import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
/* NgRx */
import { StoreModule } from "@ngrx/store";
import { NotificationFacade } from "./services/notification.facade";
import { NotificationEffects } from "./state/notification.effects";
import { notificationReducer } from "./state/notification.reducer";

@NgModule({
  imports: [
    StoreModule.forFeature("notification", notificationReducer),
    EffectsModule.forFeature([NotificationEffects])
  ],
  declarations: [],
  providers: [NotificationFacade]
})
export class NotificationModule {}
